<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.mangroupName" >
    <el-select  clearable v-model="value" placeholder="请选择" @change="ChargeBillManTree">
    <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</el-form-item>
  <el-form-item :label="formLabelAlign.obj.BillListName" >
    <el-select  clearable v-model="billvalue" placeholder="请选择" @change="ChargeBillList">
    <el-option v-for="item in BillList" :key="item.billtype" :label="item.billlabel" :value="item.billvalue">
    </el-option>
  </el-select>
</el-form-item>
   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BillTypeDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
    value:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    putIn:[{
        putInval:"0",
        putInlab:"否",
    },
    {
        putInval:"1",
        putInlab:"是",
    }],
    putInval:"",

    takeOut:[{
        takeOutval:"0",
        takeOutlab:"否",
    },
    {
        takeOutval:"1",
        takeOutlab:"是",
    }],
    takeOutval:"",

    cancelAfter:[{
        cancelAfterval:"0",
        cancelAfterlab:"否",
    },
    {
        cancelAfterval:"1",
        cancelAfterlab:"是",
    }],
    cancelAfterval:"",

    certification:[{
        certificationval:"0",
        certificationlab:"否",
    },
    {
        certificationval:"1",
        certificationlab:"是",
    }],
    certificationval:"",
    BillList:[],
    billvalue:"",
    typeName:"",
    Pid:"",
    mangroupName:"",
    };
  },
  methods: {
    ChargeBillManTree(){
        for(let val of this.options){
          if(val.value == this.value){
            // console.log(val)
            this.Pid = val.value
            this.mangroupName = val.label
          }
        }
    },
    ChargeBillList(){
        for(let val of this.BillList){
          if(val.billvalue ==  this.billvalue){
              this.typeName = val.billlabel
          }
        }
    },
    modification(){
        if(this.title == "修改"){
               let obj = {
              "id":this.formLabelAlign.id,
              "mangroupId":this.Pid,
              "mangroupName":this.value,
              "typeNum":this.billvalue,
              "typeName":this.typeName,
              "remarks":this.formLabelAlign.remarks,
              }
        if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善票据管理组"
          })
          }else if(obj.typeNum == undefined || obj.typeNum == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILLTYPE_ADD,obj).then((res) => {
      let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "添加"){
               let obj = {
              "mangroupId":this.Pid,
              "mangroupName":this.mangroupName,
              "typeNum":this.billvalue,
              "typeName":this.typeName,
              "remarks":this.formLabelAlign.remarks,
                }
          if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善票据管理组"
          })
          }else if(obj.typeNum == undefined || obj.typeNum == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILLTYPE_ADD,obj).then((res) => {
      let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                   this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }


    },
    getMsgFormSon(data){
        // console.log(data)
        this.optionsone = data
    },
    cs(){
    this.valueone = this.formLabelAlign.expendItem
    // this.disburseval = this.formLabelAlign.subjectAttributes
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
          if(this.formLabelAlign.obj == undefined){
  let obj = {
            "mangroupName":"票据管理组",
            "BillListName":"票据类型",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>